<template>
  <div class="container">
    <div class="row chat-window" id="chat_window_1" @click="needToCheck = false">
      <div class="panel panel-default" style="width:100%">
        <div class="top-bar d-flex justify-content-between">
          <div class="h5" @click="min = !min">
            <span v-if="needToCheck" class="pl-1 pr-2 text-info h6">
              <i class="fas fa-circle"></i>
            </span>
            ჩეთი
          </div>
          <div>
            <button class="btn btn-dark btn-sm" @click="sound = !sound">
              <i class="fas" :class="{ 'fa-volume-up' : sound, 'fa-volume-off' : !sound }"></i>
            </button>

            <button class="btn btn-dark btn-sm" @click="min = !min">
              <span
                id="minim_chat_window"
                class="fa"
                :class="{ 'fa-minus' : !min, 'fa-plus' : min }"
              ></span>
            </button>
          </div>
        </div>
        <div class="msg_container_base" ref="msg_container" :class="{ min : min }">
          <div
            v-for="mes in messages"
            class="msg_container"
            :class="{'base_sent' : mes.user.id == auth_user.id, 'base_receive' : mes.user.id != auth_user.id }"
            :key="mes.id"
          >
            <div
              class="messages"
              :class="{'msg_sent' : mes.user.id == auth_user.id, 'msg_receive' : mes.user.id != auth_user.id }"
            >
              <p>{{mes.text}}</p>
              <!-- <time datetime="2009-11-13T20:00">Timothy • 51 min</time> -->
              <p class="author">- {{mes.user.name}}</p>
            </div>
          </div>
        </div>

        <div class="input-group" :class="{ min : min }" v-if="!min">
          <input
            @keyup.enter="sendMsg"
            id="btn-input"
            type="text"
            class="form-control input-sm chat_input"
            placeholder="Write your message here..."
            v-model="newMsg"
          />
          <span class="input-group-btn">
            <button @click="sendMsg" class="btn btn-primary btn-sm" id="btn-chat">Send</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: ["quizroom"],
  data() {
    return {
      min: true,
      auth_user: window.App.user,
      newMsg: "",
      needToCheck: false,
      messages: [],
      sound: true
    };
  },
  methods: {
    storeMsg(text) {
      axios
        .post("/messages", {
          text: text,
          quizroom_id: this.quizroom.id
        })
        .then(res => console.log(res.data));
    },
    sendMsg() {
      if (this.newMsg == "") return;
      let text = { text: this.newMsg, user: this.auth_user };
      this.storeMsg(this.newMsg);
      this.messages.push(text);
      window.Echo.join("quizroom." + this.quizroom.code).whisper("newMsg", {
        data: text
      });
      this.newMsg = "";
      setTimeout(() => {
        this.scrollChat();
      }, 0.1);
    },
    playSound() {
      this.needToCheck = true;
      if (this.sound) {
        var audio = new Audio("/notify.mp3");
        audio.play();
      }
    },
    scrollChat() {
      this.$refs.msg_container.scrollTop = this.$refs.msg_container.scrollHeight;
    }
  },
  mounted() {
    window.Echo.join("quizroom." + this.quizroom.code).listenForWhisper(
      "newMsg",
      event => {
        this.messages.push(event.data);
        this.playSound();
        setTimeout(() => {
          this.scrollChat();
        }, 0.1);
      }
    );
    setTimeout(() => {
      axios
        .get("/messages/" + this.quizroom.id)
        .then(res => (this.messages = res.data))
        .then(() => {
          this.scrollChat();
        });
    }, 0.5);
  }
};
</script>

<style scoped src="./chat.css"></style>
